import {
  Animation,
  EasingFunction,
  SineEase,
  init_animatable,
  init_animation,
  init_easing
} from "./chunk-RMWWAV3X.mjs";

// src/modules/core/AnimationBuilder.ts
init_animation();
init_easing();
init_animatable();
var AnimationBuilder = class {
  static createAnimation(property, fromValue, toValue, speed = 1, animationType = Animation.ANIMATIONTYPE_FLOAT) {
    const ease = new SineEase();
    ease.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);
    const animation = Animation.CreateAnimation(
      property,
      animationType,
      this.fps * speed,
      ease
    );
    animation.setKeys([
      {
        frame: this.fromFrame,
        value: fromValue
      },
      {
        frame: this.toFrame,
        value: toValue
      }
    ]);
    return animation;
  }
  static createCameraVTAnimations(camera, property, value, speed = 1) {
    let animation = null;
    switch (property) {
      case "target":
      case "position":
      case "rotation":
        animation = this.createAnimation(
          property,
          camera[property].clone(),
          value,
          speed,
          Animation.ANIMATIONTYPE_VECTOR3
        );
        break;
      case "rotationQuaternion":
        animation = this.createAnimation(
          property,
          camera.rotationQuaternion.clone(),
          value,
          speed,
          Animation.ANIMATIONTYPE_QUATERNION
        );
        break;
    }
    return animation;
  }
  static createCamera3DAnimations(camera, property, value, speed = 1) {
    const TWO_PI = 2 * Math.PI;
    let animation = null;
    switch (property) {
      case "target":
        animation = this.createAnimation(
          property,
          camera.target.clone(),
          value,
          speed,
          Animation.ANIMATIONTYPE_VECTOR3
        );
        break;
      case "radius":
      case "beta":
        animation = this.createAnimation(
          property,
          camera[property],
          value,
          speed
        );
        break;
      case "alpha":
        camera.alpha = camera.alpha % TWO_PI;
        const strictValue = value % TWO_PI;
        let alphaTarget = strictValue < 0 ? TWO_PI + strictValue : strictValue;
        if (Math.abs(camera.alpha - alphaTarget) > Math.PI) {
          alphaTarget += camera.alpha < alphaTarget ? -TWO_PI : TWO_PI;
        }
        animation = this.createAnimation(
          property,
          camera.alpha,
          alphaTarget,
          speed
        );
        break;
      case "targetScreenOffset":
        animation = this.createAnimation(
          property,
          camera.targetScreenOffset.clone(),
          value,
          speed,
          Animation.ANIMATIONTYPE_VECTOR2
        );
        break;
    }
    return animation;
  }
  static createAndAddAnimations(camera, values, speed) {
    camera.animations = [];
    for (const [key, value] of Object.entries(values)) {
      let animation;
      if (camera.getClassName() === "ArcRotateCamera") {
        animation = this.createCamera3DAnimations(
          camera,
          key,
          value,
          speed
        );
      } else {
        animation = this.createCameraVTAnimations(
          camera,
          key,
          value,
          speed
        );
      }
      if (animation) {
        camera.animations.push(animation);
      }
    }
  }
};
AnimationBuilder.fps = 60;
AnimationBuilder.isLoop = false;
AnimationBuilder.fromFrame = 0;
AnimationBuilder.toFrame = 120;

export {
  AnimationBuilder
};
